import { Center } from '@/types/models'
import { isResidentialProvider } from '@/utils/providerTypeChecks'
import { RESIDENTIAL_PROVIDER_BOOST } from './constants'
export const shouldBoostResidentialProvider = (center: Center) =>
  isResidentialProvider(center) ? RESIDENTIAL_PROVIDER_BOOST : 0
